import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';

import { BodyWrapper, Header, MainWrapper } from '@components';
import { GlobalContext } from '@contexts';
import { businessMutation } from '@queries';
import { ChevronRightIcon } from '@svgs';

import { MainSidebar } from '../components/MainSidebar/MainSidebar.jsx';

import { ProjectForm } from './ProjectForm/ProjectForm.jsx';

export const AddProject = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // save datamodel
  const mutation = useMutation(
    businessMutation(null, {
      onSuccess: (data) => {
        // invalidate list views so they are re-fetched
        queryClient.invalidateQueries({ queryKey: ['businesses', 'list'] });
        // navigate to the edit view
        navigate(`/dashboard/projects/${data.id}`);
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <MainSidebar />
        <MainWrapper>
          <div className="sb-main-breadcrumbs">
            <ul className="sb-flex">
              <li className="sb-flex">
                <Link to={`/dashboard/projects`}>Projects</Link>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">Add</li>
            </ul>
          </div>
          <div className="sb-manage-content">
            <h1>Add</h1>
            <ProjectForm
              disabled={mutation.isPending}
              mutation={mutation}
              onCancel={() => {
                navigate(`/dashboard/projects`);
              }}
            />
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
